<div #animatedDigit class="animated-digit">
  <span>{{digit}}</span>
</div>
